/* KRITA by LINTEL PDP: colour buttons (native id + ?variant= for Kaching, price, gallery jump), KRITA cart drawer after any add, reels */
(function () {
  var btns = Array.prototype.slice.call(document.querySelectorAll('[data-kt-var]'));
  var form = document.querySelector('form[data-kt-add]');
  var name = document.querySelector('[data-kt-optname]');
  var now = document.querySelector('[data-kt-now]');
  var was = document.querySelector('[data-kt-was]');
  function jump(col) {
    var th = document.querySelector('.oak-gal__thumbs button[data-kt-col="' + col + '"]');
    if (th) th.click();
  }
  function pick(b, fromLoad) {
    btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
    var id = b.getAttribute('data-kt-var');
    if (form) {
      var inp = form.querySelector('input[name=id]');
      if (inp && inp.value !== id) { inp.value = id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    if (name) name.textContent = b.getAttribute('data-label') || b.getAttribute('data-col');
    if (now) now.textContent = b.getAttribute('data-now');
    if (was) was.textContent = b.getAttribute('data-was');
    if (!fromLoad) {
      try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      jump(b.getAttribute('data-col'));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: Number(id) } }));
    }
  }
  btns.forEach(function (b) { b.addEventListener('click', function () { pick(b, false); }); });
  var m = location.search.match(/[?&]variant=(\d+)/);
  if (m) {
    var hit = btns.filter(function (b) { return b.getAttribute('data-kt-var') === m[1]; })[0];
    if (hit) { pick(hit, true); setTimeout(function () { jump(hit.getAttribute('data-col')); }, 300); }
  }

  /* open the KRITA cart drawer (kt-shop.js) after any successful add — Kaching or native */
  function openDrawer() { if (window.KT) window.KT.openCart(); }
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; openDrawer(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  var vids = document.querySelectorAll('[data-kt-loop]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
})();
/* KRITA delivery timeline dates */
(function () {
  var box = document.querySelector('[data-kt-time]'); if (!box) return;
  function add(d, n) { var x = new Date(d); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) k++; } return x; }
  function f(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  var now = new Date();
  box.querySelectorAll('b[data-d]').forEach(function (b) {
    var p = b.getAttribute('data-d').split(',').map(Number);
    if (p.length === 1) { b.textContent = f(now); return; }
    b.textContent = f(add(now, p[0])) + ' – ' + f(add(now, p[1]));
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the KT brand cart drawer ===== */
(function () {
  if (window.__kt_atc) return; window.__kt_atc = 1;
  function open() { if (window.KT && window.KT.openCart) return window.KT.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
